<template>
  <el-row class="border-line">
    <el-col :span="4" style="display: flex;align-items: center;height: 120px;margin: 0 15px;justify-content: center;overflow:hidden;" >
    <!-- <el-col :sm="2" :md="2" :lg="1" :xl="4" style="display: flex;align-items: center;height: 120px;margin: 0 15px;justify-content: center;"> -->
      <img src="../assets/img/head/logo2.gif" style="height:100%" @click="$router.push('/')"/>
      <!-- <img src="../assets/img/head/logo1.png" alt="" @click="$router.push('/')"/>
      <div style="font-size: 0.28rem;line-height: 30px;padding-left:0.2rem;color: #393953;">
        <div style="letter-spacing: 0.088rem;">SEA HORSE</div>
        <div>海馬牌官方旗舰店</div>
      </div> -->
    </el-col>
    <!-- <div style="display: flex;flex-direction: column;">
      <el-col :span="18">
        <div style="height: 60px;background-color: #f2f2f2;border-radius: 0px 0px 0px 20px;font-size: 14px;" class="flex-center">
          <el-row >
            <el-col :offset="6">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
            <el-col :offset="6">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
            <el-col :span="8">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </div> -->
    <div style="display: flex;flex-direction: column;">
      <el-col :span="24">
        <div style="height: 60px;background-color: #f2f2f2;border-radius: 0px 0px 0px 20px;font-size: 0.14rem;"
          class="flex-center flex-sb">
          <!-- <ul class="flex">
            <li class="pl-3"><a href="" class="login">登入</a></li>
            <li class="pl-3"><a href="" class="nav">註冊</a></li>
            <li class="pl-3" v-for="(val,index) in navList" :key="index">
              <a href="" class="nav">
                <img :src="val.img" alt="" class="mr-1">
                {{val.name}}
              </a>
            </li>
          </ul> -->
          <div>
            <template v-if="info.id">
              <label for="" @click="$router.push('/account')">
                <img :src="info.headImg" alt="" class="ml-1 headImg" v-if="info.headImg"/>
                <img src="../assets/img/head/avatar.png" alt="" class="ml-1 headImg" v-else/>
                {{info.nickName}}
              </label>
              <label for="" class="pl-3" v-for="(val,index) in navList"  :key="index">
                <template v-if="info.id">
                  <a v-if="val.url === '#/message'" :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <el-badge :value="$store.state.messageNum" class="item">
                      <div style="position:relative;top:0.02rem;right:0.06rem">{{val.name}}</div>
                    </el-badge>
                  </a>
                  <a v-else-if="val.url === '#/cart'" :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <el-badge :value="$store.state.cartNum" class="item">
                      <div style="position:relative;top:0.02rem;right:0.06rem">{{val.name}}</div>
                    </el-badge>
                  </a>
                  <a v-else :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <div style="display:inline-block;position:relative;top:0.03rem">{{val.name }}</div>
                  </a>
                </template>
              </label>
            </template>
            <template v-else>
              <div class="flex">
                <label for="" class="pl-3">
                  <div class="login" @click="$router.push('/login?type=login')">{{ $t("index.head.login")}}</div>
                  <!-- <a href="#/login?type=login" target="_blank" class="login">{{ $t("index.head.login") }}</a> -->
                </label>
                <label for="" class="pl-3">
                  <div class="nav" @click="$router.push('/login?type=register')">{{ $t("index.head.register") }}</div>
                  <!-- <a href="#/login?type=register" target="_blank" class="nav">{{ $t("index.head.register") }}</a> -->
                </label>
              </div>
            </template>
            <!-- <label for="" class="pl-3" v-for="(val,index) in navList" v-if="info.id" :key="index">
              <a :href="val.url" class="nav">
                <img :src="val.img" alt="" class="mr-1">
                {{val.name}}
              </a>
            </label> -->
          </div>
          <div class="flex language">
            <div class="pl-3 pr-3 border-left" @click="handleToggleLanguage('CNT')">
              繁體中文
            </div>
            <div class="pl-3 pr-3 border-left" @click="handleToggleLanguage('CN')">
              简体中文
            </div>
            <div class="pl-3 pr-3 border-left" @click="handleToggleLanguage('EN')">
              English
            </div>
          </div>
        </div>
      </el-col>
      <el-col>
        <div class="flex cursor">
          <router-link to="/home" tag="div" class="nav-item">{{ $t("index.tab.page") }}</router-link>
          <router-link to="/classify" tag="div" class="nav-item">{{ $t("index.tab.classification") }}</router-link>
          <router-link to="/news" tag="div" class="nav-item">{{ $t("index.tab.center") }}</router-link>
          <router-link to="/apply" tag="div" class="nav-item">{{ $t("index.tab.cooperation") }}</router-link>
          <router-link to="/about" tag="div" class="nav-item">{{ $t("index.tab.about") }}</router-link>
          <router-link to="/contact" tag="div" class="nav-item">{{ $t("index.tab.contact") }}</router-link>
          <!-- <div class="nav-item" :class="index === 1? 'border-b':''" @click="handleNav(1)">商城首頁</div>
          <div class="nav-item" :class="index === 2? 'border-b':''" @click="handleNav(2)">商城分類</div>
          <div class="nav-item" :class="index === 3? 'border-b':''" @click="handleNav(3)">新聞中心</div>
          <div class="nav-item" :class="index === 4? 'border-b':''" @click="handleNav(4)">加盟合作</div>
          <div class="nav-item" :class="index === 5? 'border-b':''" @click="handleNav(5)">關於我們</div>
          <div class="nav-item" :class="index === 6? 'border-b':''" @click="handleNav(6)">聯絡我們</div> -->
        </div>
      </el-col>
    </div>
  </el-row>
</template>

<script>
  export default {
    name: "heade",
    data() {
      return {
        info:{},
        index:1,
        navList: [{
          name: this.$t("index.head.cart"),
          url: "#/cart",
          img: require('@/assets/img/head/cart.png')
        }, {
          name: this.$t("index.head.msg"),
          url: "#/message",
          img: require('@/assets/img/head/i-msg.png')
        }, 
        // {
        //   name: this.$t("index.head.list"),
        //   url: "#/order",
        //   img: require('@/assets/img/head/i-msg.png')
        // }, 
        {
          name: this.$t("index.head.mine"),
          url: "#/info",
          img: require('@/assets/img/head/i-personal.png')
        },]
      };
    },
    created(){
      let getItem = localStorage.getItem("TOKEN")||''
      if(getItem){
        this.userDetail()
      }
    },
    methods: {
      userDetail(){
        this.$http.post("/api/user/detail",{})
        .then(data=>{
          this.info = data
        })
      },
      handleToggleLanguage(val){
        localStorage.setItem("language",val)
        console.log(val)
        if(val == 'CNT'){
          localStorage.setItem("area",'HK')
        }else{
          localStorage.setItem("area",val)
        }
        location.reload()
      },
      handleNav(index){
        this.index = index
        if(index == 1){
          this.$router.push('/')
          return
        }
        if(index == 2){
          this.$router.push('/classify')
          return
        }
        // if(index == 3){
        //   this.$router.push('/news')
        //   return
        // }
        // if(index == 4){
        //   this.$router.push('/apply')
        //   return
        // }
        if(index == 5){
          this.$router.push('/about')
          return
        }
        if(index == 6){
          this.$router.push('/contact')
          return
        }
      }
    }
  };
</script>

<style scoped>
  .headImg{
width:38px;height:38px;border-radius:50%;border:1px solid #f2f2f2;
  }
  .border-line {
    height: 120px;
    border-bottom: 2px solid #f2f2f2;
  }
  .router-link-active{
    position: relative;
  }
  .router-link-active:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -12px;
    top: 0;
    right: 0;
    width: 24px;
    height: 6px;
    background-color: #fe5b85;
    border-radius: 4px 4px 0px 0px;
  }
  .router-link-active:after {
    top: auto;
    bottom: 0;
  }
  .router-link-active {
    position: relative;
  }

  .border-t:before,
  .border-b:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -12px;
    top: 0;
    right: 0;
    width: 24px;
    height: 6px;
    background-color: #fe5b85;
    border-radius: 4px 4px 0px 0px;
  }

  .border-b:after {
    top: auto;
    bottom: 0;
  }

  .login {
    padding: 7px 16px;
    background-color: #fe5b85;
    border-radius: 10px;
    font-size: 0.14rem;
    color: #ffffff;
    cursor: pointer;
  }

  .nav-item {
    font-size: 0.16rem;
    color: #414042;
    font-weight: bold;
    width: 172px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding-left: 30px; */
  }

  .language,
  .nav {
    font-size: 0.14rem;
    color: #414042;
    cursor: pointer;
  }

  .head {
    height: 126px;
  }

  .cursor div{
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/head.vue